/* bsd-cts-073.js — BSD-073 (14 Oct 2026): the Cut to Size buy box in the riven
   page's look. An add-on on top of assets/cut-to-size.js, which keeps all the
   logic (slab choice, cut plan, prices, dates, basket). This file only changes
   what the shopper sees, from the figures cut-to-size.js sends in its
   'cts:render' event. Wording comes from #bsd73-config (section bsd-cts-073).
   Remove the section from the template and the page goes back to how it was.
   Mock-up of record: https://claude.ai/artifact/NEpgW8okBFrR1VWeVCBYTe */
(function () {
  var cfgEl = document.getElementById('bsd73-config');
  var root = document.querySelector('.hp.cts');
  if (!cfgEl || !root) return;
  var K = {};
  try { K = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  function $(id) { return document.getElementById(id); }
  function money(p) {
    var s = (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '£' + s.replace(/\.00$/, '');
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function fill(t, map) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }

  /* ---- 1. Outcome line under the name, stars as a link to the reviews ---- */
  var title = root.querySelector('.hp__title');
  if (title && K.outcome) title.parentNode.insertBefore(el('p', 'bsd51-outcome', K.outcome), title.nextSibling);
  var sig = root.querySelector('.hp__signal b');
  if (sig && /★/.test(sig.textContent) && $('reviews')) {
    var a = el('a', 'bsd51-stars');
    a.href = '#reviews';
    a.innerHTML = '<span class="bsd51-stars__s" aria-hidden="true">★★★★★</span><span class="bsd51-stars__t">' + sig.textContent.replace(/★/g, '').trim() + '</span>';
    sig.parentNode.replaceChild(a, sig);
  }

  /* ---- 2. Badge 2 follows the finish (riven / honed: credit card flat; brushed: soft ridges) ---- */
  var badge2 = root.querySelectorAll('.hp__badgewrap')[1];
  function setBadge2(fin) {
    var b = K.badge2 && K.badge2[fin];
    if (!badge2 || !b) return;
    var lab = badge2.querySelector('.hp__badge');
    if (lab && lab.firstChild && lab.firstChild.nodeType === 3) lab.firstChild.nodeValue = b.t + ' ';
    var body = badge2.querySelector('.hp__badgebody');
    if (body && b.d) body.innerHTML = b.d;
  }

  /* ---- 3. Grade sentence in bold (the page script rewrites the line on every change) ---- */
  var gsay = $('cts-say-grd');
  if (gsay && K.gradeBold) {
    var fixG = function () {
      var t = gsay.textContent;
      if (t.indexOf(K.gradeBold) < 0 || gsay.querySelector('b')) return;
      var i = t.indexOf(K.gradeBold);
      gsay.innerHTML = '';
      gsay.appendChild(document.createTextNode(t.slice(0, i)));
      gsay.appendChild(el('b', null)).textContent = K.gradeBold;
      gsay.appendChild(document.createTextNode(t.slice(i + K.gradeBold.length)));
    };
    new MutationObserver(fixG).observe(gsay, { childList: true, characterData: true, subtree: true });
    fixG();
  }

  /* ---- 4. Limestone: one thickness as a fixed line; sizes as their own step; set line ---- */
  var thk = $('cts-thk');
  if (thk && K.thkFixed) {
    var thkStep = thk.closest('.hp__step');
    thkStep.style.display = 'none';
    var fx = el('div', 'bsd73-thk', '<span class="hp__steplabel">' + K.thkLabel + '</span><div class="bsd73-thk__v">' + K.thkFixed + '</div>');
    thkStep.parentNode.insertBefore(fx, thkStep.nextSibling);
  }
  var cut = $('cts-step-cut');
  if (cut && K.sizesLabel) {
    var sub = cut.querySelector('.hp__sub');
    var st = el('div', 'hp__step', '<span class="hp__steplabel"><span class="hp__num" data-n>0</span> ' + K.sizesLabel + '</span>');
    cut.parentNode.insertBefore(st, cut.nextSibling);
    if (sub) st.appendChild(sub);
    if (K.sizesNote) st.appendChild(el('p', 'hp__say', K.sizesNote));
  }
  var setLine = $('bsd73-setline');
  if (setLine && cut) {
    setLine.hidden = false;
    var pcs = $('cts-pcs');
    pcs.parentNode.insertBefore(setLine, pcs.nextSibling);
  }

  /* ---- 5. "When do you need it?": two side-by-side choices instead of the dropdown ---- */
  var spd = $('cts-spd');
  var cards = el('div', 'bsd73-when');
  cards.setAttribute('role', 'radiogroup');
  cards.innerHTML = ['standard', 'priority'].map(function (k) {
    return '<button type="button" class="bsd73-when__c" role="radio" data-speed="' + k + '" aria-checked="false">'
      + '<span class="bsd73-when__n">' + (k === 'priority' ? K.priorityWord : K.standardWord) + '</span>'
      + '<span class="bsd73-when__d"></span><span class="bsd73-when__m"></span></button>';
  }).join('');
  var diff = el('p', 'bsd73-when__diff');
  if (spd) {
    spd.style.display = 'none';
    spd.parentNode.insertBefore(cards, spd.nextSibling);
    cards.parentNode.insertBefore(diff, cards.nextSibling);
    cards.addEventListener('click', function (e) {
      var b = e.target.closest('.bsd73-when__c');
      if (!b) return;
      spd.value = b.getAttribute('data-speed');
      spd.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---- 6. Delivery dropdown off (chosen at checkout); one grey delivery card above the button ---- */
  var del = $('cts-del');
  if (del) del.closest('.hp__step').style.display = 'none';
  var form = $('hp-form');
  var card = el('div', 'bsd51-del', '<p class="bsd51-del__h"></p><p class="bsd51-del__p"></p>' + (K.delPhoto ? '<p class="bsd51-del__p">' + K.delPhoto + '</p>' : ''));
  if (form) form.parentNode.insertBefore(card, form);

  /* ---- 7. Under the button: crack guarantee line, then "measure twice" ---- */
  if (form && K.guarantee) {
    var g = el('p', 'bsd51-guar bsd51-guar--crack', '<span>' + K.guarantee + '</span>');
    form.parentNode.insertBefore(g, form.nextSibling);
    var hand = root.querySelector('.hp__hand');
    if (hand) g.parentNode.insertBefore(hand, g.nextSibling);
  }

  /* ---- Every render: price line, choice cards, delivery card, badge 2 ---- */
  document.addEventListener('cts:render', function (e) {
    var d = e.detail || {};
    var vat = root.querySelector('.hp__pricevat');
    if (vat) vat.textContent = K.vat + (d.ok ? ' · ' + fill(K.split, { slab: money(d.slabs), cut: money(d.svc) }) : '');
    cards.querySelectorAll('.bsd73-when__c').forEach(function (b) {
      var p = b.getAttribute('data-speed') === 'priority';
      b.setAttribute('aria-checked', String(d.speed === (p ? 'priority' : 'standard')));
      b.querySelector('.bsd73-when__d').innerHTML = fill(K.cardDate, { date: '<b>' + (p ? d.priShort : d.stdShort) + '</b>' });
      b.querySelector('.bsd73-when__m').textContent = fill(K.cardMeta, { days: p ? d.priDays : d.stdDays, price: money(p ? d.pri : d.std) });
    });
    diff.textContent = d.pri > d.std ? fill(K.diffLine, { diff: money(d.pri - d.std) }) : '';
    var date = d.speed === 'priority' ? d.priDate : d.stdDate;
    card.querySelector('.bsd51-del__h').textContent = fill(K.delHead, { date: date });
    card.querySelectorAll('.bsd51-del__p')[0].innerHTML = fill(K.delLine, { price: money(d.pallet) });
    card.hidden = !!d.soldOut;
    setBadge2(d.fin);
  });

  /* cut-to-size.js drew the page before this file ran: ask it to draw once more. */
  if (spd) spd.dispatchEvent(new Event('change', { bubbles: true }));
})();